import type { FC } from "react";
import { Route, Redirect, type RouteProps } from "react-router-dom";
import { useUrlWithSearchParams } from "../../helpers/routeHelpers";
import { useMctFlags } from "../../helpers/flag-hooks/useMctFlags";
import { useAppState } from "../../helpers/context-hooks/useAppState";

export const ProviderNetworkRoute: FC<RouteProps> = ({ children, ...rest }) => {
  const { tmpFeEnableProviderNetwork } = useMctFlags();
  const { year } = useAppState();
  const enableProviderNetwork =
    tmpFeEnableProviderNetwork && !!year && +year > 2025;

  const redirect = useUrlWithSearchParams("/");

  if (enableProviderNetwork) {
    return <Route {...rest}>{children}</Route>;
  }
  // Provider Network not enabled, go to landing page.
  return <Redirect to={redirect} />;
};
